<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{'cities.property.title' | transloco}}</nz-page-header-title>
    <nz-page-header-extra>
      <a routerLink="new" nz-button nzType="primary">
        <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
      </a>
    </nz-page-header-extra>
  </nz-page-header>
</nz-affix>

<nz-table *transloco="let tr; prefix: 'cities'; scope: 'cities'" [nzLoading]="isLoading.properties" #listTable
          [nzData]="properties" [nzShowPagination]="false">
  <thead>
  <tr>
    <th>{{tr('property.column.key')}}</th>
    <th>{{tr('property.column.value')}}</th>
    <th nzWidth="100px">#</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let data of listTable.data">
    <td>
      <i nz-icon [nzType]="data.enabled ? 'check-circle': 'minus-circle'" [nzTwotoneColor]="data.enabled ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
      {{ data.key }}
    </td>
    <td>
      <ng-container *ngIf="data.key !== 'cityMap'">{{ data.value | json }}</ng-container>
      <ng-container *ngIf="data.key === 'cityMap'">***</ng-container>
    </td>
    <td>
      <nz-button-group>
        <button [routerLink]="data.key + '/edit'" nz-button nzType="primary">
          <i nz-icon nzType="edit" nzTheme="outline"></i>
        </button>
        <button nz-button nzType="default" nzDanger nz-popconfirm
                [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                [nzCancelText]="'no1' | transloco"
                (nzOnConfirm)="remove(data.id)">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </button>
      </nz-button-group>
    </td>
  </tr>
  </tbody>
</nz-table>
